<script>
import InlineSVG from 'svelte-inline-svg'
import { providers } from '../common'

let usmapPath = '/img/us-map-with-cities.svg' // edit with https://www.vecteezy.com/editor

</script>
<section>
  <div class="section-body">
  <!-- <div class="row">
    <div class="col-xs-12 col-sm-3 col-md-2 col-lg-1">
      <div class="box-row"></div>
    </div>
    <div class="col-xs-6 col-sm-6 col-md-8 col-lg-10">
      <div class="box-row"></div>
    </div>
    <div class="col-xs-6 col-sm-3 col-md-2 col-lg-1">
      <div class="box-row"></div>
    </div>
  </div> -->



    <div classA="row">
      <!-- <div class="col-xs-0 col-sm-0 col-md-3 col-lg-4 col-xl-4"></div> -->
      <div classA="col-lg-8">
        <div class="ioreveal animate__animated animate__delay-3s" data-anicss="animate__fadeInUp" style="animation-delay: .1s;">
        <p class="leading">
        Steer has analyzed more than 60 million bike share trips made in the past two years to understand: <strong style="color: #18c7de">how COVID-19 impacted bike share use in cities across the US and how this may have long-term impacts on bike share usage as cities emerge from lockdowns?</strong>
        </p>
        <p>
        We selected 6 major cities in the US which have historically had high transit ridership and recent increases in demand for micromobility.
        </p>

        </div>
        <div class="ioreveal animate__animated animate__delay-3s mt-5" data-anicss="animate__fadeInUp" style="animation-delay: .4s;">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <!-- The following bike programmes were analysed. -->
              <ul>
              {#each providers as provider}
                <li>
                  {provider.name}, {provider.city} - <a href="{'https://' + provider.url}" target="_blank">{provider.urlShort}</a><br>
                  <!-- <img src="{provider.logo}" alt="{provider.name}" style="height: { provider.logoHeight }"> -->
                </li>
              {/each}
              </ul>
              </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <InlineSVG src={usmapPath} width="100%" height="100%" />

            </div>
          </div>
        </div>
        <div class="ioreveal animate__animated animate__delay-3s" data-anicss="animate__fadeIn" style="animation-delay: 1s; font-size:11px; color: #ddd; line-height:150%">
        All data sourced is valid from January 2019 to March 2021 except for Biketown, Portland with data valid only until August 2020.
        <br>
        The data will be updated once Q2 2021 data is available.
        </div>
        <div class="ioreveal animate__animated animate__delay-3s mt-2" data-anicss="animate__fadeIn" style="animation-delay: 1.1s;Amargin-top:-10px">
        {#each providers as provider}
          <span>
            <img src="{provider.logo}" alt="{provider.name}" style="height: { provider.logoHeight }">
          </span>
        {/each}
        </div>
      </div>
    </div>
  </div>
</section>

<style>
.row {
  text-align: left;
}
.section-body {
  /* max-width: 960px;
  padding: 30px;
  margin: auto; */
  /* margin-left: 200px; */
  text-align: left;
}

p {
  /* font-size: 1.2rem;
  line-height: 1.8rem; */
}

li {
  margin-bottom: 10px;
}
li img {
  margin: 5px 0 6px 0;
  /* height: 22px; */
}

.leading {
  font-size:1.2rem;
}
</style>